import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import "./UserDashboard.css";
import "../../GlobalCss/SPF/UserDashboard.css";
import Cookies from "js-cookie";
import axios from 'axios';
import { Redirect } from "react-router-dom";
import { Tooltip, Button, message, Modal, Avatar, Select, Space, Empty, Spin, Popconfirm, Dropdown, Menu } from "antd";
import { RightOutlined, LeftOutlined, CheckCircleOutlined, UserAddOutlined, PlusSquareOutlined, LoadingOutlined, DeleteOutlined, MoreOutlined, PlusOutlined } from "@ant-design/icons";
import {
    getAllAlerts,
    getTotalGroupPercentage
} from "../../redux/DashboardRedux/DashboardActions";

const AdminDashboard = () => {

    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");
    const dispatch = useDispatch();
    const [leftArrow, showLeftArrow] = useState(null);
    const setRightArrowDiv = (index) => {
        showLeftArrow(index)
    }
    const setLeftArrowDiv = (index) => {
        showLeftArrow(null)
    }

    const [leftArrow1, showLeftArrow1] = useState(null);
    const setRightArrowDiv1 = (index) => {
        showLeftArrow1(index)
    }
    const setLeftArrowDiv1 = (index) => {
        showLeftArrow1(null)
    }

    const [leftArrow2, showLeftArrow2] = useState(null);
    const setRightArrowDiv2 = (index) => {
        showLeftArrow2(index)
    }
    const setLeftArrowDiv2 = (index) => {
        showLeftArrow2(null)
    }

    const [leftArrow3, showLeftArrow3] = useState(null);
    const setRightArrowDiv3 = (index) => {
        showLeftArrow3(index)
    }
    const setLeftArrowDiv3 = (index) => {
        showLeftArrow3(null)
    }

    const [leftArrow4, showLeftArrow4] = useState(null);
    const setRightArrowDiv4 = (index) => {
        showLeftArrow4(index)
    }
    const setLeftArrowDiv4 = (index) => {
        showLeftArrow4(null)
    }

    const firstLetters = userLogin
        .split('@')[0]
        .split('.')
        .map(part => part[0])
        .join('').toUpperCase();

    const [currentDate, setCurrentDate] = useState(new Date());

    const getWeekDays = () => {
        const weekdays = [];
        const startDate = new Date(currentDate);
        startDate.setDate(startDate.getDate() - startDate.getDay() + 1);
        for (let i = 0; i < 7; i++) {
            const day = new Date(startDate);
            day.setDate(startDate.getDate() + i);
            weekdays.push(day);
        }
        return weekdays;
    };

    const handlePreviousDay = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() - 7);
        setCurrentDate(newDate);
    };

    const handleNextDay = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() + 7);
        setCurrentDate(newDate);
    };
    var options = { weekday: 'short' };
    var prnDt = new Date().toLocaleDateString('en-US', options);
    const [selectedDate, setSelectedDate] = useState(prnDt);
    const [selectedDateFull, setSelectedDateFull] = useState(new Date());

    const handleDateClick = (day) => {
        setopenTaskLoading(true)
        setSelectedDateFull(new Date(day));
        const weekdayName = day.toLocaleDateString('en-US', { weekday: 'short' });
        taskDetails(weekdayName);
        taskDetailsOfUsers(weekdayName)
        dispatch(getAllAlerts());
    }
    const weekdays = getWeekDays();

    const [usertasks, getUsertasks] = useState([]);
    const [tasks, gettasks] = useState([]);
    const [completedTasks, getCompletedTasks] = useState([]);
    const [backlogTasks, getBacklogTasks] = useState([]);
    const [userODtasks, getODtasks] = useState([]);
    const [UsercompletedTasks, getCompletedTasksofusers] = useState([]);
    const [taskid, setTaskId] = useState([]);
    const [users, getUsers] = useState([]);
    const [user, setUser] = useState();
    const [gruops, getGroups] = useState([]);
    const [tasknames, getTasknames] = useState([]);
    const [assignes, getAssignes] = useState([]);
    const [taskname, setTaskname] = useState([]);
    const [groupname, setGroupname] = useState([]);
    const [username, setUsername] = useState([]);
    const [Dueday, SetDueday] = useState([]);

    const [taskLoading, setTaskLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [taskloader, setTaskLoader] = useState({})
    const [openTask, setopenTask] = useState(false);
    const [openbacklogtask, setOpenBacklogtask] = useState(false);
    const [openTaskLoading, setopenTaskLoading] = useState(false);
    const [openBacklogLoading, setopenBacklogLoading] = useState(false);
    const [opencreatetask, setCreatetask] = useState(false);
    const [openReassign, setopenReassign] = useState(false)
    const [error, setError] = useState('')
    const [errorReassign, setErrorReassign] = useState('')
    const [showCompletedTasks, setShowCompletedTasks] = useState(false);
    const [showCompletedTasksUsers, setUserShowCompletedTasks] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const toggleCompletedTasks = () => {
        setShowCompletedTasks(!showCompletedTasks);
    };
    const toggleCompletedTasksUsers = () => {
        setUserShowCompletedTasks(!showCompletedTasksUsers);
    };

    const taskDetails = async (day) => {
        let selDate = day
        setSelectedDate(selDate)
        try {
            await axios({
                url:
                    `${process.env.REACT_APP_BASE_URL}UserTask/CalculateOverDue?`
                    + `&day=` + selDate,
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            })
                .then((resp) => {
                    getUsertasks(resp.data)
                    setopenTaskLoading(false)
                    setTaskLoader(false)
                    gettasks(resp.data)
                    console.log("API response:", resp.data);
                })
        }
        catch (error) {
            message.error("Unbale to load your tasks")
            setopenTaskLoading(false)
            setTaskLoader(false)
        }
    };

    useEffect(() => {
        setopenTaskLoading(true)
        taskDetails(selectedDate);
    }, []);

    useEffect(() => {
        dispatch(getAllAlerts());
        CompletedTasks()
    }, []);
    const alertsData = useSelector(
        (state) => state.dashboardreducer.totalAlerts
    )

    const CompletedTasks = async () => {
        const url = `${process.env.REACT_APP_BASE_URL}UserTask/GetCompletedUsertask`
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        try {
            const res = await axios.get(url, config)
            if (res.data.statusCode === 200) {
                const resdata = res.data.payload
                const data = JSON.parse(resdata)
                getCompletedTasks(data)
            }
            else if (res.data.statusCode === 500) {
                message.warning(response.data.message)
            }
        }
        catch (error) {
            // message.error('Error, Try again..');
        }

    };

    const BacklogTasks = async () => {
        const url = `${process.env.REACT_APP_BASE_URL}UserTask/GetBackLogUsertask`
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        try {
            const res = await axios.get(url, config)
            if (res.data.statusCode === 200) {
                const resdata = res.data.payload
                const data = JSON.parse(resdata)
                getBacklogTasks(data)
                setopenBacklogLoading(false)
            }
            else if (res.data.statusCode === 500) {
                message.warning(response.data.message)
            }
        }
        catch (error) {
            message.error('Error, Try again..');
        }

    };

    useEffect(() => {
        setopenBacklogLoading(true)
        BacklogTasks()
    }, [])

    const userList = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/GetUserUnderManagers?`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getUsers(resp.data))
    };
    useEffect(() => {
        userList();
    }, []);

    const assigneList = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/GetAllUserID's`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getAssignes(resp.data))
    };

    useEffect(() => {
        assigneList();
    }, []);

    const taskDetailsOfUsers = async (day) => {
        let selDate = day
        setSelectedDate(selDate)
        try {
            await axios({
                url:
                    `${process.env.REACT_APP_BASE_URL}UserTask/CalculateOverDue`
                        `&day=` + selDate,
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            })
                .then((resp) => {
                    gettasks(resp.data)
                    setTaskLoading(false)
                    console.log("taskDetails",resp.data)
                })
        }
        catch (error) {
            setTaskLoading(false)
        }
    };

    useEffect(() => {
        setTaskLoading(true)
        taskDetailsOfUsers(selectedDate);
    }, [user])

    const ODtaskDetailsOfUsers = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/Alerts`,
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getODtasks(resp.data))
    };
    useEffect(() => {
        ODtaskDetailsOfUsers();
        CompletedTasksOfUsers()
    }, [user]);

    const CompletedTasksOfUsers = async () => {
        const url = `${process.env.REACT_APP_BASE_URL}UserTask/GetCompletedUsertask`
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        try {
            const res = await axios.get(url, config)
            if (res.data.statusCode === 200) {
                const resdata = res.data.payload
                const data = JSON.parse(resdata)
                getCompletedTasksofusers(data)
            }
            else if (res.data.statusCode === 500) {
                message.warning(response.data.message)
            }
        }
        catch (error) {
            //    message.error('Error, Try again..');
        }
    };

    const getTaskId = (item) => {
        setTaskId(item)
    }

    const handleStatusUpdate = async (value, index) => {

        const url = `${process.env.REACT_APP_BASE_URL}UserTask/updatestatus?taskid=` + value + `&status=Completed&uname=` + userLogin;
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        const data = [];
        setTaskLoader(prevState => ({ ...prevState, [index]: true }))
        try {
            const res = await axios.post(url, data, config)
            const resp = await taskDetails(selectedDate);
            dispatch(getAllAlerts());
            const comData = await CompletedTasks();
            message.success(`Updated your task status successfully.`);
            dispatch(getTotalGroupPercentage())
            showLeftArrow(null)
            showLeftArrow1(null)
            showLeftArrow2(null)
            showLeftArrow3(null)
            showLeftArrow4(null)
        }
        catch (error) {
            message.error('Task status is not Updated, Try again..');
            setTaskLoader(prevState => ({ ...prevState, [index]: false }))
            showLeftArrow(null)
            showLeftArrow1(null)
            showLeftArrow2(null)
            showLeftArrow3(null)
            showLeftArrow4(null)
        }

    };

    const handleReassign = async (value) => {
        if (username.length === 0) {
            setErrorReassign('Please select user');
            return;
        }
        const url = `${process.env.REACT_APP_BASE_URL}UserTask/ReassaignTask?tasksid=` + value + `&assagneeid=` + username
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        const data = [];
        try {
            setLoading(true);
            const res =
                await axios.post(url, data, config)
                    .then((response) => {
                        message.success(`Assigned successfully.`);
                        setopenReassign(false);
                        setLoading(false);
                        setUsername([])
                        setErrorReassign('')
                        showLeftArrow(null)
                        showLeftArrow1(null)
                        showLeftArrow2(null)
                        showLeftArrow3(null)
                        showLeftArrow4(null)
                    })
        }
        catch (error) {
            message.error('Error, Try again..');
            setopenReassign(false)
            setLoading(false);
            setUsername([])
            setErrorReassign('')
            showLeftArrow(null)
            showLeftArrow1(null)
            showLeftArrow2(null)
            showLeftArrow3(null)
            showLeftArrow4(null)
        }
        taskDetailsOfUsers(selectedDate);
        ODtaskDetailsOfUsers();
        taskDetails(selectedDate);
        dispatch(getAllAlerts());
        userList();
        BacklogTasks();
    };

    const handleDelete = async (value) => {

        const url = `${process.env.REACT_APP_BASE_URL}UserTask/RemoveUsertask?taskid=` + value
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        try {
            const res = await axios.delete(url, config)
            if (res.data.statusCode === 200) {
                message.success('Deleted successfully!');
                showLeftArrow(null)
                showLeftArrow1(null)
                showLeftArrow2(null)
                showLeftArrow3(null)
                showLeftArrow4(null)
            }
            else if (response.data.statusCode === 500) {
                message.warning(response.data.message)
                showLeftArrow(null)
                showLeftArrow1(null)
                showLeftArrow2(null)
                showLeftArrow3(null)
                showLeftArrow4(null)
            }
        }
        catch (error) {
            message.error('Error, Try again..');
            showLeftArrow(null)
            showLeftArrow1(null)
            showLeftArrow2(null)
            showLeftArrow3(null)
            showLeftArrow4(null)
        }
        taskDetailsOfUsers(selectedDate);
        ODtaskDetailsOfUsers();
        taskDetails(selectedDate);
        dispatch(getAllAlerts());
        userList();
        BacklogTasks();
    };

    const getGroupnames = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/GetGroups`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getGroups(resp.data))
    };
    useEffect(() => {
        getGroupnames();
    }, []);

    const encodedGroupname = encodeURIComponent(groupname);
    const encodedTaskname = encodeURIComponent(taskname);
    const gettasknames = () => {
        setTaskname([])
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/GetTasksBasedonGroup?groupname=` + encodedGroupname,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getTasknames(resp.data))
    };
    useEffect(() => {
        gettasknames();
    }, [encodedGroupname]);

    const handleGroupname = (e) => {
        setGroupname(e.target.value);
    }

    const handleTaskname = (e) => {
        setTaskname(e.target.value);
    }

    const handleUser = (item) => {
        setUser(item);
        showModalForTasks();
    }
    const handleDueday = (e) => {
        SetDueday(e.target.value);
    }

    const Days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    const handleCreateTask = async () => {
        if (groupname.length === 0 || taskname.length === 0 || username.length === 0 || Dueday.length === 0) {
            setError('Please select all fields');
            return;
        }
        const url = `${process.env.REACT_APP_BASE_URL}UserTask/CreateTask?uname=`
            + userLogin + `&task=` + encodedTaskname + `&assaignuser=` + username + `&groupname=` + encodedGroupname + `&inputday=` + Dueday;
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        const data = [];
        try {
            setLoading(true);
            const res =
                await
                    axios.post(url, data, config)
                        .then((response) => {
                            userList();
                            taskDetails(selectedDate);
                            dispatch(getAllAlerts());
                            taskDetailsOfUsers(selectedDate);
                            ODtaskDetailsOfUsers();
                            message.success(`Created successfully.`);
                            setCreatetask(false);
                            setGroupname([])
                            setTaskname([])
                            setUsername([])
                            SetDueday([])
                            getTasknames([])
                            setError('');
                            setLoading(false);
                        })
        }
        catch (error) {
            message.error("Try again...")
            setLoading(false);
            setCreatetask(false);
            setGroupname([])
            setTaskname([])
            setUsername([])
            SetDueday([])
        }

    };

    const showModalForTasks = () => {
        setopenTask(true);
    };
    const handleCancelforTask = () => {
        setopenTask(false);
        getCompletedTasksofusers([])
        setUserShowCompletedTasks(false)
    }
    const showModalForBacklog = () => {
        setOpenBacklogtask(true);
    };
    const handleCancelBacklog = () => {
        setOpenBacklogtask(false)
    }
    const showModalCreateTask = () => {
        setCreatetask(true);
    };
    const handleCancelforCreateTask = () => {
        setGroupname([])
        setTaskname([])
        setUsername([])
        SetDueday([])
        getTasknames([])
        setCreatetask(false);
        setError('')
    }

    const showModalForReassign = () => {
        setopenReassign(true);
    };

    const handleCancelReassign = () => {
        setUsername([])
        setErrorReassign('')
        setopenReassign(false);
    };
    var totalBacklogtasks = backlogTasks.length
    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }
    const menu = (
        <Menu>
            <Menu.Item style={{ color: "rgba(59, 82, 223, 1)", fontFamily: "open sans" }} key="1" onClick={showModalCreateTask}>
                Create New <PlusOutlined />
            </Menu.Item>
            <Menu.Item style={{ color: "rgba(59, 82, 223, 1)", fontFamily: "open sans" }} key="2" onClick={showModalForBacklog}>
                Backlog Tasks({totalBacklogtasks})
            </Menu.Item>
        </Menu>
    );
    const filteredTasks = user ? tasks.filter(task => task.assignedTo_User_Id === user) : tasks;
    const filteredODTasks = user ? userODtasks.filter(task => task.assignedTo_User_Id === user) : userODtasks;
    const filteredCompletedTasks = user ? UsercompletedTasks.filter(task => task.AssignedTo_User_Id === user) : UsercompletedTasks;

    
    
    return (
        <>
            <div className="wholediv-for-usertasks">
                <div className="usertasks">
                    <div className="calendar-view">
                        <div className="calendar-div">
                            <input onClick={handlePreviousDay} value="<" type="button"
                                className="move" />
                            <div className="inside-calender">
                                {
                                    weekdays.map((day, index) => (
                                        <Tooltip placement="top" title={day.getDate() + ", " + (day.toLocaleString('en-US', { month: 'long' }))} color={'rgba(59, 82, 223, 1)'}>
                                            <div
                                                key={index}
                                                className={`${day.toDateString() === new Date().toDateString() ? 'highlight' : 'day-name'} 
                                                            ${day.toDateString() === selectedDateFull.toDateString() ? 'selected-date' : ''}`}
                                                onClick={() => handleDateClick(day)}>
                                                <p style={{ textAlign: "center", marginLeft: "10%", color: 'rgba(59, 82, 223, 1)', fontWeight: "600", }}>{day.toLocaleDateString('en-US', { weekday: 'short' })}</p>
                                                <p style={{ textAlign: "center", marginTop: "13px", color: day.toDateString() === new Date().toDateString() ? 'rgba(255, 192, 105, 1)' : 'rgba(140, 140, 140, 1)' }}>{day.getDate()}</p>
                                            </div>
                                        </Tooltip>
                                    ))
                                }
                            </div>

                            <input onClick={handleNextDay} value=">" type="button"
                                className="move" />
                        </div>
                        <div className="users-list">
                            <div className="users-div">
                                {
                                    users ? users.map((item, index) => {
                                        const first = item.split('@')[0]
                                            .split('.')
                                            .map(part => part[0])
                                            .join('').toUpperCase();
                                        return (<div className="user-card">
                                            <Tooltip color={'rgba(59, 82, 223, 1)'} key={index} title={item}   onClick={() => handleUser(item)}>
                                                <Avatar
                                                   
                                                    style={{
                                                        backgroundColor: 'rgba(59, 82, 223, 1)',
                                                    }}
                                                    size={{
                                                        sm: 30,
                                                    }}
                                                >{first}
                                                </Avatar>
                                            </Tooltip>
                                        </div>)
                                    }) : null
                                }
                                <Modal
                                    open={openTask}
                                    onCancel={handleCancelforTask}
                                    width={700}
                                    className="modal-styling"
                                    footer={[null]}
                                >
                                    {
                                        taskLoading ? <div className="render-tasks">
                                            <div className="example">
                                                <Spin />
                                            </div>
                                        </div> :
                                            <div className="backlog-task-div">
                                                <div>
                                                    {
                                                        filteredTasks.length !== 0 ?
                                                            <div >{
                                                                filteredTasks.map((item, index) => {
                                                                    const email = item.assignedTo_User_Id.split('@')[0]
                                                                        .split('.')
                                                                        .map(part => part[0])
                                                                        .join('').toUpperCase();
                                                                    return (
                                                                        <div className="tasklist-class">
                                                                            <div className="inside-tasks" onClick={() => getTaskId(item.taskId)}>
                                                                                <div className="avatar-div">
                                                                                    <Tooltip color={'rgba(59, 82, 223, 1)'} key={index} title={item.assignedTo_User_Id}>
                                                                                        <Avatar
                                                                                            style={{
                                                                                                backgroundColor: 'rgba(59, 82, 223, 1)',
                                                                                                cursor: "pointer"
                                                                                            }}
                                                                                            size={{
                                                                                                sm: 32,
                                                                                            }}
                                                                                        >
                                                                                            {email}
                                                                                        </Avatar>
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <div className="name-arrow-class">
                                                                                    <div className="taskname-class">
                                                                                        <div className="task-name">
                                                                                            {item.taskName}
                                                                                        </div>
                                                                                        <div className="today-date">
                                                                                            {item.task_Status}
                                                                                        </div>

                                                                                    </div>
                                                                                    {
                                                                                        leftArrow2 === index ?
                                                                                            <div className="arrow-icon-div">
                                                                                                <Popconfirm
                                                                                                    title="Are you sure want to delete?"
                                                                                                    onConfirm={() => handleDelete(item.taskId)}
                                                                                                    okText="Yes"
                                                                                                    cancelText="No"
                                                                                                >
                                                                                                    <Tooltip color={'rgba(59, 82, 223, 1)'} title="Delete task"><DeleteOutlined className="del-icon" /></Tooltip>
                                                                                                </Popconfirm>
                                                                                                <Tooltip color={'rgba(59, 82, 223, 1)'} title="Reassign task"><UserAddOutlined className="status-icon" onClick={showModalForReassign} /></Tooltip>
                                                                                                <Modal
                                                                                                    open={openReassign}
                                                                                                    onCancel={handleCancelReassign}
                                                                                                    footer={[
                                                                                                        <Button style={{ backgroundColor: "rgba(59, 82, 223, 1)" }} key="submit" type="primary" loading={loading} onClick={() => handleReassign(item.taskId)} >
                                                                                                            Submit
                                                                                                        </Button>,
                                                                                                    ]}
                                                                                                >
                                                                                                    <label style={{ marginRight: 10, fontWeight: 600, color: "rgba(59, 82, 223, 1)" }}>Assign To:  </label>
                                                                                                    <Select
                                                                                                        // size="x large"
                                                                                                        placeholder="Select User"
                                                                                                        width={300}
                                                                                                        value={username}
                                                                                                        onChange={(newUser) => {
                                                                                                            setUsername(newUser);
                                                                                                        }}
                                                                                                    >
                                                                                                        {assignes.map((items, index) => {
                                                                                                            return (
                                                                                                                <Select.Option key={index} value={items} width={300} >
                                                                                                                    {items}
                                                                                                                </Select.Option>
                                                                                                            );
                                                                                                        })}
                                                                                                    </Select>
                                                                                                    {errorReassign && <p style={{ color: 'red' }}>{errorReassign}</p>}
                                                                                                </Modal>
                                                                                                <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv2(index)} />
                                                                                            </div>
                                                                                            : <div className="arrow-icon">
                                                                                                <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv2(index)} />
                                                                                            </div>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                            : <div>
                                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                                    className="notask-heading"
                                                                    description={
                                                                        <span>
                                                                            No tasks for the day
                                                                        </span>
                                                                    }
                                                                >
                                                                </Empty>
                                                                {/* <h1 className="notask-heading">No tasks for the day</h1> */}
                                                            </div>
                                                    }
                                                </div>
                                                <div className="overdue-tasks">
                                                    {
                                                        filteredODTasks.length !== 0 ?
                                                            <div >{
                                                                filteredODTasks.map((item, index) => {
                                                                    const email = item.assignedTo_User_Id.split('@')[0]
                                                                        .split('.')
                                                                        .map(part => part[0])
                                                                        .join('').toUpperCase();
                                                                    return (
                                                                        <div className="tasklist-class">
                                                                            <div className="inside-tasks" onClick={() => getTaskId(item.taskId)}>
                                                                                <div className="avatar-div">
                                                                                    <Tooltip color={'rgba(59, 82, 223, 1)'} key={index} title={item.assignedTo_User_Id}>
                                                                                        <Avatar
                                                                                            style={{
                                                                                                backgroundColor: 'rgba(59, 82, 223, 1)',
                                                                                                cursor: "pointer"
                                                                                            }}
                                                                                            size={{
                                                                                                sm: 32,
                                                                                            }}
                                                                                        >
                                                                                            {email}
                                                                                        </Avatar>
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <div className="name-arrow-class">
                                                                                    <div className="taskname-class">
                                                                                        <div className="task-name">
                                                                                            {item.taskName}
                                                                                        </div>
                                                                                        <div className="today-date" style={{ color: "rgba(255, 163, 158, 1)" }}>
                                                                                            Overdue since {item.task_Due_Date}
                                                                                        </div>
                                                                                    </div>
                                                                                    {
                                                                                        leftArrow3 === index ?
                                                                                            <div className="arrow-icon-div">
                                                                                                <Popconfirm
                                                                                                    title="Are you sure want to delete?"
                                                                                                    onConfirm={() => handleDelete(item.taskId)}
                                                                                                    okText="Yes"
                                                                                                    cancelText="No"
                                                                                                >
                                                                                                    <Tooltip color={'rgba(59, 82, 223, 1)'} title="Delete task"><DeleteOutlined className="del-icon" /></Tooltip>
                                                                                                </Popconfirm>
                                                                                                <Tooltip color={'rgba(59, 82, 223, 1)'} title="Reassign task"><UserAddOutlined className="status-icon" onClick={showModalForReassign} /></Tooltip>
                                                                                                <Modal
                                                                                                    open={openReassign}
                                                                                                    onCancel={handleCancelReassign}
                                                                                                    footer={[
                                                                                                        <Button style={{ backgroundColor: "rgba(59, 82, 223, 1)" }} key="submit" type="primary" loading={loading} onClick={() => handleReassign(item.taskId)} >
                                                                                                            Submit
                                                                                                        </Button>,
                                                                                                    ]}
                                                                                                >
                                                                                                    <label style={{ marginRight: 10, fontWeight: 600, color: "rgba(59, 82, 223, 1)" }}>Assign To:  </label>
                                                                                                    <Select
                                                                                                        size="x large"
                                                                                                        placeholder="Select User"
                                                                                                        value={username}
                                                                                                        onChange={(newUser) => {
                                                                                                            setUsername(newUser);
                                                                                                        }}
                                                                                                    >
                                                                                                        {assignes.map((items, index) => {
                                                                                                            return (
                                                                                                                <Select.Option key={index} value={items} >
                                                                                                                    {items}
                                                                                                                </Select.Option>
                                                                                                            );
                                                                                                        })}
                                                                                                    </Select>
                                                                                                    {errorReassign && <p style={{ color: 'red' }}>{errorReassign}</p>}
                                                                                                </Modal>
                                                                                                <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv3(index)} />
                                                                                            </div>
                                                                                            : <div className="arrow-icon">
                                                                                                <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv3(index)} />
                                                                                            </div>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                            : <div >
                                                                {/* <h1 className="notask-heading" style={{ marginLeft: "44%" }}>No tasks</h1> */}
                                                            </div>

                                                    }
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                                                    <a onClick={toggleCompletedTasksUsers} style={{ textDecoration: "underline", color: "rgba(59, 82, 223, 1)", fontWeight: "600", fontFamily: "Open Sans" }}>
                                                        {showCompletedTasksUsers ? 'Hide Completed Tasks' : 'Show Completed Tasks'}
                                                    </a>
                                                </div>
                                                <div>
                                                    {showCompletedTasksUsers && (
                                                        <div className="overdue-tasks">
                                                            {filteredCompletedTasks.length !== 0 ? (
                                                                <div >{
                                                                    filteredCompletedTasks.map((item, index) => {
                                                                        const email = item.AssignedTo_User_Id.split('@')[0]
                                                                            .split('.')
                                                                            .map(part => part[0])
                                                                            .join('').toUpperCase();
                                                                        return (
                                                                            <div className="tasklist-class">
                                                                                <div className="inside-tasks">
                                                                                    <div className="avatar-div">
                                                                                        <Avatar
                                                                                            style={{
                                                                                                backgroundColor: 'rgba(59, 82, 223, 1)',
                                                                                                cursor: "pointer"
                                                                                            }}
                                                                                        >
                                                                                            {email}
                                                                                        </Avatar>
                                                                                    </div>
                                                                                    <div className="name-arrow-class">
                                                                                        <div className="taskname-class">
                                                                                            <div className="task-name" key={index}>
                                                                                                {item.TaskName}
                                                                                            </div>
                                                                                            <div className="today-date" style={{ color: "rgba(143, 184, 72, 1)" }}>
                                                                                                Completed
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                                        className="notask-heading"
                                                                    >
                                                                    </Empty>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>}
                                </Modal>
                            </div>
                            <div className="menu-dropdown-div">
                                <Dropdown overlay={menu} trigger={['click']}>
                                    <a onClick={(e) => e.preventDefault()}>
                                        <MoreOutlined style={{ fontSize: 32, color: "rgba(59, 82, 223, 1)", marginTop: "4px" }} />
                                    </a>
                                </Dropdown>
                                <Modal
                                    open={openbacklogtask}
                                    onCancel={handleCancelBacklog}
                                    width={700}
                                    className="modal-styling"
                                    footer={[null]}
                                >
                                    {
                                        openBacklogLoading ? <div className="render-tasks">
                                            <div className="example">
                                                <Spin />
                                            </div>
                                        </div> : <div className="backlog-task-div">
                                            {
                                                backlogTasks.length !== 0 ?
                                                    <div >{
                                                        backlogTasks.map((item, index) => {
                                                            const first = item.AssignedTo_User_Id.split('@')[0]
                                                                .split('.')
                                                                .map(part => part[0])
                                                                .join('').toUpperCase();
                                                            return (
                                                                <div className="tasklist-class">
                                                                    <div className="inside-tasks" >
                                                                        <div className="avatar-div">
                                                                            <Tooltip color={'rgba(59, 82, 223, 1)'} key={index} title={item.AssignedTo_User_Id}>
                                                                                <Avatar
                                                                                    style={{
                                                                                        backgroundColor: 'rgba(59, 82, 223, 1)',
                                                                                        cursor: "pointer"
                                                                                    }}
                                                                                >
                                                                                    {first}
                                                                                </Avatar>
                                                                            </Tooltip>
                                                                        </div>
                                                                        <div className="name-arrow-class">
                                                                            <div className="taskname-class">
                                                                                <div className="task-name">
                                                                                    {item.TaskName}
                                                                                </div>
                                                                                <div className="today-date" style={{ color: item.Task_Status === 'Over Due' ? 'rgba(255, 163, 158, 1)' : 'rgba(151, 151, 151, 1)' }}>
                                                                                    {item.Task_Status} since {item.LastUpdatedDate.split('T')[0]}
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                leftArrow4 === index ?
                                                                                    <div className="arrow-icon-div">
                                                                                        <Popconfirm
                                                                                            title="Are you sure want to delete?"
                                                                                            onConfirm={() => handleDelete(item.TaskId)}
                                                                                            okText="Yes"
                                                                                            cancelText="No"
                                                                                        >
                                                                                            <Tooltip color={'rgba(59, 82, 223, 1)'} title="Delete task"><DeleteOutlined className="del-icon" /></Tooltip>
                                                                                        </Popconfirm>
                                                                                        <Tooltip color={'rgba(59, 82, 223, 1)'} title="Reassign task"><UserAddOutlined className="status-icon" onClick={showModalForReassign} /></Tooltip>
                                                                                        <Modal
                                                                                            open={openReassign}
                                                                                            onCancel={handleCancelReassign}
                                                                                            footer={[
                                                                                                <Button style={{ backgroundColor: "rgba(59, 82, 223, 1)" }} key="submit" type="primary" loading={loading} onClick={() => handleReassign(item.TaskId)} >
                                                                                                    Submit
                                                                                                </Button>,
                                                                                            ]}
                                                                                        >
                                                                                            <label style={{ marginRight: 10, fontWeight: 600, color: "rgba(59, 82, 223, 1)" }}>Assign To:  </label>
                                                                                            <Select
                                                                                                size="x large"
                                                                                                placeholder="Select User"
                                                                                                value={username}
                                                                                                onChange={(newUser) => {
                                                                                                    setUsername(newUser);
                                                                                                }}
                                                                                            >
                                                                                                {assignes.map((items, index) => {
                                                                                                    return (
                                                                                                        <Select.Option key={index} value={items} >
                                                                                                            {items}
                                                                                                        </Select.Option>
                                                                                                    );
                                                                                                })}
                                                                                            </Select>
                                                                                            {errorReassign && <p style={{ color: 'red' }}>{errorReassign}</p>}
                                                                                        </Modal>
                                                                                        <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv4(index)} />
                                                                                    </div>
                                                                                    : <div className="arrow-icon">
                                                                                        <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv4(index)} />
                                                                                    </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                    : <div>
                                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                            className="notask-heading"
                                                            description={
                                                                <span>
                                                                    No Backlog Tasks
                                                                </span>
                                                            }
                                                        >
                                                        </Empty>
                                                        {/* <h1 className="notask-heading">No tasks for the day</h1> */}
                                                    </div>
                                            }
                                        </div>}
                                </Modal>
                                <Modal
                                    open={opencreatetask}
                                    onCancel={handleCancelforCreateTask}
                                    footer={[
                                        <Button style={{ backgroundColor: "rgba(59, 82, 223, 1)" }} key="submit" type="primary" loading={loading} onClick={handleCreateTask}>
                                            Create
                                        </Button>,
                                    ]}
                                >
                                    <Space wrap>
                                        <Select
                                            size="x large"
                                            placeholder="Select Group"
                                            style={{ width: 150 }}
                                            value={groupname}
                                            options={gruops.map((group) => ({
                                                label: group,
                                                value: group,
                                            }))}
                                            onChange={(newGroup) => {
                                                setGroupname(newGroup)
                                            }}
                                        />
                                        <Select
                                            size="x large"
                                            placeholder="Select Task"
                                            style={{ width: 200 }}
                                            value={taskname}
                                            options={tasknames.map((task) => ({
                                                label: task,
                                                value: task,
                                            }))}
                                            onChange={(newTask) => {
                                                setTaskname(newTask)
                                            }}
                                        />
                                    </Space>
                                    <br />
                                    <br />
                                    <label style={{ marginRight: 10, fontWeight: 600, color: "rgba(59, 82, 223, 1)" }}>Assign To:  </label>
                                    <Select
                                        size="x large"
                                        placeholder="Select User"
                                        style={{ width: 150 }}
                                        value={username}
                                        options={assignes.map((assign) => ({
                                            label: assign,
                                            value: assign,
                                        }))}
                                        onChange={(newUser) => {
                                            setUsername(newUser);
                                        }}
                                    />
                                    <br />
                                    <br />
                                    <label style={{ marginRight: 10, fontWeight: 600, color: "rgba(59, 82, 223, 1)" }}>Task Due Day:  </label>
                                    <Select
                                        mode="multiple"
                                        size="x large"
                                        style={{ width: 150 }}
                                        value={Dueday}
                                        placeholder="Select Dueday"
                                        allowClear
                                        maxTagCount="responsive"
                                        options={Days.map((Week) => ({
                                            label: Week,
                                            value: Week,
                                        }))}
                                        onChange={(newDay) => {
                                            SetDueday(newDay);
                                        }}
                                    />
                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                </Modal>
                            </div>

                        </div>
                    </div>
                    <div className="usertasks-display">
                        {openTaskLoading ? <div className="render-tasks">
                            <div className="example">
                                <Spin size="large" />
                            </div>
                        </div>
                            : <div className="render-tasks">
                                <div>
                                    {
                                        usertasks.length !== 0 ?
                                            <div >{
                                                usertasks.map((item, index) => {
                                                    // Safe function to extract initials
                                                    const getInitials = (userId) => {
                                                        if (!userId) return 'NA';
                                                        const username = userId.includes('@') ? userId.split('@')[0] : userId;
                                                        const parts = username.trim().split(/[.\s_]/); // handles dot, space, underscore
                                                        return parts.map(p => p[0]).join('').toUpperCase(); // MM, LK, etc.
                                                    };

                                                    const firstLetters = getInitials(item.assignedTo_User_Id);

                                                    return (
                                                        <div className="tasklist-class" key={item.taskId}>
                                                            <div className="inside-tasks" onClick={() => getTaskId(item.taskId)}>
                                                                <div className="avatar-div">
                                                                    <Avatar
                                                                        style={{
                                                                            backgroundColor: 'rgba(59, 82, 223, 1)',
                                                                        }}
                                                                    >
                                                                        {firstLetters}
                                                                    </Avatar>
                                                                </div>
                                                                <div className="name-arrow-class">
                                                                    <div className="taskname-class">
                                                                        <div className="task-name">{item.taskName}</div>
                                                                        <div className="today-date">{item.task_Status}</div>
                                                                    </div>
                                                                    {
                                                                        leftArrow === index ? (
                                                                            <div className="arrow-icon-div">
                                                                                <Popconfirm
                                                                                    title="Are you sure want to delete?"
                                                                                    onConfirm={() => handleDelete(item.taskId)}
                                                                                    okText="Yes"
                                                                                    cancelText="No"
                                                                                >
                                                                                    <Tooltip title="Delete task">
                                                                                        <DeleteOutlined className="del-icon" />
                                                                                    </Tooltip>
                                                                                </Popconfirm>
                                                                                <Tooltip color={'rgba(59, 82, 223, 1)'} title="Reassign task"><UserAddOutlined className="status-icon" onClick={showModalForReassign} /></Tooltip>
                                                                                <Modal
                                                                                    open={openReassign}
                                                                                    onCancel={handleCancelReassign}
                                                                                    footer={[
                                                                                        <Button style={{ backgroundColor: "rgba(59, 82, 223, 1)" }} key="submit" type="primary" loading={loading} onClick={() => handleReassign(item.taskId)} >
                                                                                            Submit
                                                                                        </Button>,
                                                                                    ]}
                                                                                >
                                                                                    <label style={{ marginRight: 10, fontWeight: 600, color: "rgba(59, 82, 223, 1)" }}>Assign To:  </label>
                                                                                    <Select
                                                                                        size="x large"
                                                                                        placeholder="Select User"
                                                                                        value={username}
                                                                                        onChange={(newUser) => {
                                                                                            setUsername(newUser);
                                                                                        }}
                                                                                    >
                                                                                        {assignes.map((items, index) => {
                                                                                            return (
                                                                                                <Select.Option key={index} value={items} >
                                                                                                    {items}
                                                                                                </Select.Option>
                                                                                            );
                                                                                        })}
                                                                                    </Select>
                                                                                    {errorReassign && <p style={{ color: 'red' }}>{errorReassign}</p>}
                                                                                </Modal>
                                                                                <Tooltip title="Click here to mark as completed">
                                                                                    {taskloader[index] ? <LoadingOutlined className="status-icon" /> :
                                                                                        <CheckCircleOutlined className="status-icon" onClick={() => handleStatusUpdate(item.taskId, index)} />}
                                                                                </Tooltip>
                                                                                <LeftOutlined className="navigation-leftarrow" onClick={() => setLeftArrowDiv(index)} />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="arrow-icon">
                                                                                <RightOutlined className="navigation-rightarrow" onClick={() => setRightArrowDiv(index)} />
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}

                                            </div>
                                            : <div>
                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                    className="notask-heading"
                                                    description={
                                                        <span>
                                                            No tasks for the day
                                                        </span>
                                                    }
                                                >
                                                </Empty>
                                                {/* <h1 className="notask-heading">No tasks for the day</h1> */}
                                            </div>
                                    }
                                </div>
                                <div className="overdue-tasks">
                                    {
                                        alertsData.length !== 0 ?
                                            <div >{
                                                alertsData.map((item, index) => {
                                                    // Safe function to extract initials
                                                    const getInitials = (userId) => {
                                                        if (!userId) return 'NA';
                                                        const username = userId.includes('@') ? userId.split('@')[0] : userId;
                                                        const parts = username.trim().split(/[.\s_]/); // handles dot, space, underscore
                                                        return parts.map(p => p[0]).join('').toUpperCase(); // MM, LK, etc.
                                                    };

                                                    const firstLetters = getInitials(item.assignedTo_User_Id);
                                                    return (
                                                        <div className="tasklist-class">
                                                            <div className="inside-tasks" onClick={() => getTaskId(item.taskId)}>
                                                                <div className="avatar-div">
                                                                    <Avatar
                                                                        style={{
                                                                            backgroundColor: 'rgba(59, 82, 223, 1)',
                                                                        }}
                                                                    >
                                                                        {firstLetters}
                                                                    </Avatar>
                                                                </div>
                                                                <div className="name-arrow-class">
                                                                    <div className="taskname-class">
                                                                        <div className="task-name">
                                                                            {item.taskName}
                                                                        </div>
                                                                        <div className="today-date" style={{ color: "rgba(255, 163, 158, 1)" }}>
                                                                            Overdue since {item.task_Due_Date}
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        leftArrow1 === index ?
                                                                            <div className="arrow-icon-div">
                                                                                <Popconfirm
                                                                                    title="Are you sure want to delete?"
                                                                                    onConfirm={() => handleDelete(item.taskId)}
                                                                                    okText="Yes"
                                                                                    cancelText="No"
                                                                                >
                                                                                    <Tooltip color={'rgba(59, 82, 223, 1)'} title="Delete task"><DeleteOutlined className="del-icon" /></Tooltip>
                                                                                </Popconfirm>
                                                                                <Tooltip color={'rgba(59, 82, 223, 1)'} title="Reassign task"><UserAddOutlined className="status-icon" onClick={showModalForReassign} /></Tooltip>
                                                                                <Modal
                                                                                    open={openReassign}
                                                                                    onCancel={handleCancelReassign}
                                                                                    footer={[
                                                                                        <Button style={{ backgroundColor: "rgba(59, 82, 223, 1)" }} key="submit" type="primary" loading={loading} onClick={() => handleReassign(item.taskId)} >
                                                                                            Submit
                                                                                        </Button>,
                                                                                    ]}
                                                                                    >
                                                                                    <label style={{ marginRight: 10, fontWeight: 600, color: "rgba(59, 82, 223, 1)" }}>Assign To:  </label>
                                                                                    <Select
                                                                                        size="x large"
                                                                                        placeholder="Select User"
                                                                                        value={username}
                                                                                        onChange={(newUser) => {
                                                                                            setUsername(newUser);
                                                                                        }}
                                                                                    >
                                                                                        {assignes.map((items, index) => {
                                                                                            return (
                                                                                                <Select.Option key={index} value={items} >
                                                                                                    {items}
                                                                                                </Select.Option>
                                                                                            );
                                                                                        })}
                                                                                    </Select>
                                                                                    {errorReassign && <p style={{ color: 'red' }}>{errorReassign}</p>}
                                                                                </Modal>
                                                                                <Tooltip color={'rgba(59, 82, 223, 1)'} title="Click here to mark as completed">
                                                                                    {taskloader[index] ? <LoadingOutlined className="status-icon" /> :
                                                                                        <CheckCircleOutlined className="status-icon" onClick={() => handleStatusUpdate(item.taskId, index)} />}
                                                                                </Tooltip>
                                                                                <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv1(index)} />
                                                                            </div>
                                                                            : <div className="arrow-icon">
                                                                                <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv1(index)} />
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            : <div>
                                                {/* <h1 className="notask-heading" style={{ marginLeft: "45%" }}>No tasks</h1> */}
                                            </div>
                                    }
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", marginBottom: "12px" }}>
                                    <a onClick={toggleCompletedTasks} style={{ textDecoration: "underline", color: "rgba(59, 82, 223, 1)", fontWeight: "600", fontFamily: "Open Sans" }}>
                                        {showCompletedTasks ? 'Hide Completed Tasks' : 'Show Completed Tasks'}
                                    </a>
                                </div>
                                <div>
                                    {showCompletedTasks && (
                                        <div className="overdue-tasks" >
                                            {completedTasks.length !== 0 ? (

                                                <div >{
                                                    completedTasks.map((item, index) => {
                                                        return (
                                                            <div className="tasklist-class">
                                                                <div className="inside-tasks">
                                                                    <div className="avatar-div">
                                                                        <Avatar
                                                                            style={{
                                                                                backgroundColor: 'rgba(59, 82, 223, 1)',
                                                                                cursor: "pointer"
                                                                            }}
                                                                        >
                                                                            {firstLetters}
                                                                        </Avatar>
                                                                    </div>
                                                                    <div className="name-arrow-class">
                                                                        <div className="taskname-class">
                                                                            <div className="task-name" key={index}>
                                                                                {item.TaskName}
                                                                            </div>
                                                                            <div className="today-date" style={{ color: "rgba(143, 184, 72, 1)" }}>
                                                                                Completed
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            ) : (
                                                <div>
                                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                        className="notask-heading"
                                                    >
                                                    </Empty>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
        </>

    );
}
export default AdminDashboard;